export default () => ({
  gridItem: {
    width: '100%',
  },
});
